import React, { useState } from "react";
import MyTab from "../Interactions/MyTab";
import InternationalBronzeAchievement from "./InternationalBronzeAchievement";
import InternationalGoldAchievement from "./InternationalGoldAchievement";
import InternationalSilverAchievement from "./InternationalSilverAchievement";
const items = [
  {
    key: "1",
    label: "Gold Achievements",
    children: <InternationalGoldAchievement />,
  },
  {
    key: "2",
    label: "Silver Achievements",
    children: <InternationalSilverAchievement />,
  },
  {
    key: "3",
    label: "Bronze Achievements",
    children: <InternationalBronzeAchievement />,
  },
];

const InternationalAchievementsTabs = ({
  setAchievement,
  setSelectedStepher,
}) => {
  const [activeTab, setActiveTab] = useState("1");
  return (
    <MyTab
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      setAchievement={setAchievement}
      items={items}
    />
  );
};
export default InternationalAchievementsTabs;
